import { api } from "@/services";
import { API_ENDPOINTS } from "@/config";
import { truncateDecimals, formatRawTokenAmount } from "@/utils";
import type { UnwindingPositionStore } from "@/hooks";
import { LOCK_TOKEN_DECIMALS } from "@/config";

export interface APIUserUnwindingPosition {
    startUnwindingTimestampMs: number;
    startUnwindingTimestampUTC: string;
    unwindingStartEpoch: number;
    unwindingStartEpochUTC: string;
    unwindingEndEpoch: number;
    unwindingEndEpochUTC: string;
    unwindingTokenSymbol: string;
    unwindingTokenAddress: string;
    unwindingEpochs: number;
    currentAmount: string; // iUSD
    currentAmountNormalized: number;
    unwindingAmount: string; // iUSD when starting unwinding
    profitSinceUnwinding: string; // iUSD
    profitSinceUnwindingNormalized: number;
    unwindingAmountNormalized: number;
}

export const fetchUserUnwinding = async (address: string): Promise<UnwindingPositionStore[]> => {
    try {
        const response = await api.get<{ data: APIUserUnwindingPosition[] }>(
            API_ENDPOINTS.UNWINDING.GET_USER_UNWINDING(address),
        );

        return response.data.data.map((position) => {
            const properDecimalConvertedBalance = formatRawTokenAmount(
                BigInt(position.unwindingAmount),
                LOCK_TOKEN_DECIMALS,
            );
            const properDecimalRewardBalance = formatRawTokenAmount(
                BigInt(position.profitSinceUnwinding),
                LOCK_TOKEN_DECIMALS,
            );

            return {
                id: `${position.startUnwindingTimestampMs}-${position.unwindingEpochs}-${position.currentAmount}`,
                lockDuration: `${position.unwindingEpochs}w`,
                lockedBalance: truncateDecimals(properDecimalConvertedBalance),
                rewardsEarned: truncateDecimals(properDecimalRewardBalance),
                startDate: position.unwindingStartEpochUTC,
                endDate: position.unwindingEndEpochUTC,
                epochsRemaining: position.unwindingEpochs,
                startUnwindingTimestampMs: position.startUnwindingTimestampMs,
                startUnwindingEpoch: position.unwindingStartEpoch,
            };
        });
    } catch (error) {
        console.error("Error fetching unwinding data:", error);
        throw error;
    }
};
